export interface AccreditationTypeListProps {
    onSubmit: (accreditationTypes: number[]) => void;
    selectedAccreditationTypes: number[];
}

export const SelectableTypes = [
    {
        name: "Accredited",
        value: 1
    }, {
        name: "Accredited Distance Education",
        value: 4
    }, {
        name: "Letter of Review",
        value: 5,
    }
];

export enum AccreditationType {
    "accredited" = 1,
    "initial" = 2,
    "withdrawn" = 3,
    "distance" = 4,
    "review" = 5,
}
